// extracted by mini-css-extract-plugin
module.exports = {"card":"Facts2_card__1GFbt","footer":"Facts2_footer__3q_f-","header":"Facts2_header__FIjMT","wrapper":"Facts2_wrapper__2XJQw"};